module.exports = __webpack_public_path__ + "img/qc.78300313.png";